'use es6';

import { Map as ImmutableMap } from 'immutable';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { InlineBarChart } from 'foundations-components/transitional/components/InlineBarChart';
import { TableCell as TD } from 'foundations-components/transitional/components/Table';
import { getCellBlockSize } from '../../tableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineBarChartLabel = ({
  valueLinks,
  onClick,
  valueLabels,
  renderArgs
}) => {
  if (valueLinks.first()) {
    return /*#__PURE__*/_jsx(Link, {
      href: valueLinks.first(),
      external: true,
      children: valueLabels.first()
    });
  }
  if (onClick) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: () => onClick(renderArgs),
      use: "link",
      children: valueLabels.first()
    });
  }
  return valueLabels.first();
};
export default function BarChartCell(renderArgs) {
  const {
    column: {
      onClick: onColumnClick,
      showAsBarChartOptions = ImmutableMap()
    },
    field,
    value,
    dataset,
    valueLabels,
    valueLinks,
    onPointClick,
    isMobile
  } = renderArgs;
  const onClick = onPointClick || onColumnClick;
  const max = showAsBarChartOptions.get('max') || dataset.get('data').map(datum => datum.get(field)).max();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TD, {
      textAlign: "right",
      blockSize: getCellBlockSize(isMobile),
      paddingInlineEnd: "400 !important",
      children: /*#__PURE__*/_jsx(InlineBarChartLabel, {
        valueLinks: valueLinks,
        onClick: onClick,
        valueLabels: valueLabels,
        renderArgs: renderArgs
      })
    }), /*#__PURE__*/_jsx(TD, {
      textAlign: "left",
      blockSize: getCellBlockSize(isMobile),
      paddingInlineStart: "0 !important",
      children: /*#__PURE__*/_jsx(InlineBarChart, {
        value: value,
        max: !max && max !== 0 ? 1 : max,
        paddingInlineStart: 0
      })
    })]
  });
}